import {
  Key_instancebefxze3q9f64 as Key_instance,
  get_job2zvlvce9o9a29 as get_job,
  Job13y4jkazwjho0 as Job,
} from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Job.mjs';
import { KtorCallContextElementudwxlrp3zgdl as KtorCallContextElement } from './Utils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { asyncz02dsa2nb2zt as async } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { HttpRequestBuilder15f2nnx9sjuv1 as HttpRequestBuilder } from '../request/HttpRequest.mjs';
import { PrimitiveClasses_getInstance143761yrsca9q as PrimitiveClasses_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/primitives.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  createKType31ecntyyaay3k as createKType,
  getStarKTypeProjection316vzroubdy0t as getStarKTypeProjection,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { TypeInfo2nbxsuf4v8os2 as TypeInfo } from '../../../../../ktor-ktor-utils/io/ktor/util/reflect/Type.mjs';
import {
  OutgoingContent3t2ohmyam9o76 as OutgoingContent,
  NullBody_instanceyfq32eqie90j as NullBody_instance,
} from '../../../../../ktor-ktor-http/io/ktor/http/content/OutgoingContent.mjs';
import {
  get_HttpRequestIsReadyForSending2qftypei374ml as get_HttpRequestIsReadyForSending,
  get_HttpResponseReceived23ai4hzotyx3a as get_HttpResponseReceived,
  get_HttpResponseCancelled3685lnxbzknld as get_HttpResponseCancelled,
} from '../utils/ClientEvents.mjs';
import { HttpClientCall2j6myj8ctykar as HttpClientCall } from '../call/HttpClientCall.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { ClientEngineClosedException1qtw9cl0kd5fk as ClientEngineClosedException } from './HttpClientEngineBase.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { Phases_getInstance2m4et9xkapx2y as Phases_getInstance } from '../request/HttpRequestPipeline.mjs';
import { AutoCloseable1l5p57f9lp7kv as AutoCloseable } from '../../../../../kotlin-kotlin-stdlib/kotlin/AutoCloseableJs.mjs';
import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  HttpHeaders_getInstance3m47m69p49qfb as HttpHeaders_getInstance,
  UnsafeHeaderException3ncvrrp48xjzq as UnsafeHeaderException,
} from '../../../../../ktor-ktor-http/io/ktor/http/HttpHeaders.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { CoroutineName2g5zosw74tf0f as CoroutineName } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineName.mjs';
import { HttpClientConfigo6p492ed655g as HttpClientConfig } from '../HttpClientConfig.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { AttributeKey3aq8ytwgx54f7 as AttributeKey } from '../../../../../ktor-ktor-utils/io/ktor/util/Attributes.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_CALL_COROUTINE() {
  _init_properties_HttpClientEngine_kt__h91z5h();
  return CALL_COROUTINE;
}
var CALL_COROUTINE;
function get_CLIENT_CONFIG() {
  _init_properties_HttpClientEngine_kt__h91z5h();
  return CLIENT_CONFIG;
}
var CLIENT_CONFIG;
function _get_closed__iwkfs1($this) {
  var tmp0_safe_receiver = $this.bw().bd(Key_instance);
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.cw();
  return !(tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs);
}
function *executeWithinCallContext($this, requestData, $completion) {
  var callContext = yield* createCallContext($this, requestData.k5l_1, $completion);
  var context = callContext.pm(new (KtorCallContextElement())(callContext));
  return yield* async($this, context, VOID, HttpClientEngine$executeWithinCallContext$slambda($this, requestData)).vy($completion);
}
function checkExtensions($this, requestData) {
  var _iterator__ex2g4s = requestData.m5l_1.p1();
  while (_iterator__ex2g4s.q1()) {
    var requestedExtension = _iterator__ex2g4s.r1();
    // Inline function 'kotlin.require' call
    if (!$this.n5l().t2(requestedExtension)) {
      var message = "Engine doesn't support " + toString(requestedExtension);
      throw IllegalArgumentException().n2(toString(message));
    }
  }
}
function HttpClientEngine$install$slambda($client, this$0) {
  return constructCallableReference(function *($this$intercept, content, $completion) {
    // Inline function 'kotlin.apply' call
    var this_0 = new (HttpRequestBuilder())();
    this_0.o5l($this$intercept.t4s_1);
    // Inline function 'io.ktor.client.request.setBody' call
    if (content == null) {
      this_0.z5h_1 = NullBody_instance;
      // Inline function 'io.ktor.util.reflect.typeInfo' call
      var tmp = PrimitiveClasses_getInstance().rf();
      // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
      var tmp_0;
      try {
        tmp_0 = createKType(PrimitiveClasses_getInstance().rf(), arrayOf([]), false);
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Error) {
          var _unused_var__etf5q3 = $p;
          tmp_1 = null;
        } else {
          throw $p;
        }
        tmp_0 = tmp_1;
      }
      var tmp$ret$4 = tmp_0;
      var tmp$ret$3 = new (TypeInfo())(tmp, tmp$ret$4);
      this_0.p5l(tmp$ret$3);
    } else {
      if (content instanceof OutgoingContent()) {
        this_0.z5h_1 = content;
        this_0.p5l(null);
      } else {
        this_0.z5h_1 = content;
        // Inline function 'io.ktor.util.reflect.typeInfo' call
        var tmp_2 = PrimitiveClasses_getInstance().rf();
        // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
        var tmp_3;
        try {
          tmp_3 = createKType(PrimitiveClasses_getInstance().rf(), arrayOf([]), false);
        } catch ($p_0) {
          var tmp_4;
          if ($p_0 instanceof Error) {
            var _unused_var__etf5q3_0 = $p_0;
            tmp_4 = null;
          } else {
            throw $p_0;
          }
          tmp_3 = tmp_4;
        }
        var tmp$ret$6 = tmp_3;
        var tmp$ret$5 = new (TypeInfo())(tmp_2, tmp$ret$6);
        this_0.p5l(tmp$ret$5);
      }
    }
    var builder = this_0;
    $client.i5g_1.z4t(get_HttpRequestIsReadyForSending(), builder);
    // Inline function 'kotlin.apply' call
    var this_1 = builder.i37();
    this_1.l5l_1.i4n(get_CLIENT_CONFIG(), $client.j5g_1);
    var requestData = this_1;
    validateHeaders(requestData);
    checkExtensions(this$0, requestData);
    var responseData = yield* /*#__NOINLINE__*/executeWithinCallContext(this$0, requestData, $completion);
    var call = HttpClientCall().i5j($client, requestData, responseData);
    var response = call.p5g();
    $client.i5g_1.z4t(get_HttpResponseReceived(), response);
    var tmp_5 = get_job(response.bw());
    tmp_5.ex((it) => {
      var tmp;
      if (!(it == null)) {
        $client.i5g_1.z4t(get_HttpResponseCancelled(), response);
        tmp = Unit_instance;
      }
      return Unit_instance;
    });
    yield* $this$intercept.v4r(call, $completion);
    return Unit_instance;
  }, 2);
}
function HttpClientEngine$executeWithinCallContext$slambda(this$0, $requestData) {
  return constructCallableReference(function *($this$async, $completion) {
    var tmp;
    if (_get_closed__iwkfs1(this$0)) {
      throw ClientEngineClosedException().v5l();
    }
    return yield* this$0.w5l($requestData, $completion);
  }, 1);
}
function get_supportedCapabilities() {
  return emptySet();
}
function install(client) {
  var tmp = Phases_getInstance().x5g_1;
  client.e5g_1.x4s(tmp, HttpClientEngine$install$slambda(client, this));
}
var HttpClientEngineClass;
function HttpClientEngine() {
  if (HttpClientEngineClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'HttpClientEngine', VOID, VOID, [AutoCloseable()], [1]);
    HttpClientEngineClass = $;
  }
  return HttpClientEngineClass;
}
function validateHeaders(request) {
  _init_properties_HttpClientEngine_kt__h91z5h();
  var requestHeaders = request.i5l_1;
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = requestHeaders.q4p();
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().p2();
  var _iterator__ex2g4s = tmp0.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    if (HttpHeaders_getInstance().v50_1.t2(element)) {
      destination.i2(element);
    }
  }
  var unsafeRequestHeaders = destination;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!unsafeRequestHeaders.n1()) {
    throw UnsafeHeaderException().t51(toString(unsafeRequestHeaders));
  }
}
function *createCallContext(_this__u8e3s4, parentJob, $completion) {
  var callJob = Job(parentJob);
  var callContext = _this__u8e3s4.bw().pm(callJob).pm(get_CALL_COROUTINE());
  $l$block: {
    // Inline function 'io.ktor.client.engine.attachToUserJob' call
    var callJob_0 = callJob;
    // Inline function 'kotlinx.coroutines.currentCoroutineContext' call
    // Inline function 'kotlin.js.getCoroutineContext' call
    var tmp0_elvis_lhs = $completion.pc().bd(Key_instance);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      break $l$block;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var userJob = tmp;
    var cleanupHandler = userJob.gx(true, VOID, (cause) => {
      if (cause == null)
        return Unit_instance;
      var tmp1_elvis_lhs = cause instanceof CancellationException() ? cause : null;
      var cancellation = tmp1_elvis_lhs == null ? CancellationException().n(cause.message) : tmp1_elvis_lhs;
      callJob_0.lx(cancellation);
      return Unit_instance;
    });
    callJob_0.ex((it) => {
      cleanupHandler.sz();
      return Unit_instance;
    });
  }
  return callContext;
}
var properties_initialized_HttpClientEngine_kt_5uiebb;
function _init_properties_HttpClientEngine_kt__h91z5h() {
  if (!properties_initialized_HttpClientEngine_kt_5uiebb) {
    properties_initialized_HttpClientEngine_kt_5uiebb = true;
    CALL_COROUTINE = new (CoroutineName())('call-context');
    // Inline function 'io.ktor.util.AttributeKey' call
    var name = 'client-config';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp = getKClass(HttpClientConfig());
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_0;
    try {
      tmp_0 = createKType(getKClass(HttpClientConfig()), arrayOf([getStarKTypeProjection()]), false);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_1 = null;
      } else {
        throw $p;
      }
      tmp_0 = tmp_1;
    }
    var tmp$ret$2 = tmp_0;
    var tmp$ret$1 = new (TypeInfo())(tmp, tmp$ret$2);
    CLIENT_CONFIG = new (AttributeKey())(name, tmp$ret$1);
  }
}
//region block: exports
export {
  get_CLIENT_CONFIG as get_CLIENT_CONFIG1oazdiwjd1qe0,
  install as install34ed8l0uhurm0,
  get_supportedCapabilities as get_supportedCapabilities36x6e2ixit204,
  HttpClientEngine as HttpClientEngine3f41d0b7i209y,
};
//endregion

//# sourceMappingURL=HttpClientEngine.mjs.map
